import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const CtaBanner = ({banner}) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            }, 
            { threshold: 0.3 }
        );

        if (sectionRef.current) observer.observe(sectionRef.current);
        
        return () => {
            if (sectionRef.current) observer.disconnect();
        };
    }, []);

    return (
        <section className="split-cta-section">
      <div className="container-fluid p-0 h-100">
        <div className="row g-0 h-100">

          <div className="col-12 h-100 position-relative overflow-hidden">
            <div className="split-img-mask">
             <Link to="/shop">
              <img
                src={banner?.image}
                alt="banner"
                className="split-img"
              /></Link>

             
            </div>

            {/* Stamp same */}
            {/* <div className="rotating-stamp">
              <svg viewBox="0 0 200 200" width="140" height="140">
                <defs>
                  <path id="circlePath" d="M 100, 100 m -75, 0 a 75,75 0 1,1 150,0 a 75,75 0 1,1 -150,0" />
                </defs>
                <text width="200">
                  <textPath href="#circlePath" className="stamp-text">
                    • PURE INGREDIENTS • NATURAL GLOW • 
                  </textPath>
                </text>
              </svg>
              <div className="stamp-center">✦</div>
            </div> */}

          </div>

        </div>
      </div>
    </section>
    );
};

export default CtaBanner;